export const ED_LANDING_PAGE = '/mens-health/erectile-dysfunction'
export const ED_QUIZ_PAGE = `${ED_LANDING_PAGE}/quiz`
export const ED_PORTAL_PAGE = '/portal/treatments/ed'

export const PE_LANDING_PAGE = '/mens-health/premature-ejaculation'
export const PE_QUIZ_PAGE = `${PE_LANDING_PAGE}/quiz`
export const PE_PORTAL_PAGE = '/portal/treatments/pe'

export const MHL_LANDING_PAGE = '/mens-health/hair-loss'
export const MHL_QUIZ_PAGE = `${MHL_LANDING_PAGE}/quiz`
export const MHL_PORTAL_PAGE = '/portal/treatments/mhl'

export const WL_LANDING_PAGE = '/weight-loss'
export const WL_QUIZ_PAGE = `${WL_LANDING_PAGE}/quiz`
export const WL_PORTAL_PAGE = '/portal/treatments/wl'
